import Dialog from '@/components/Dialog';
import { type ButtonProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const DangerousDialogSaveButton = (props: ButtonProps) => (
  <Dialog.Actions.Button color="error" {...props}>
    <FormattedMessage id="dialogs.actions.save" />
  </Dialog.Actions.Button>
);

export default DangerousDialogSaveButton;
